<template>
  <v-dialog v-model="localDialog" width="500">
    <common-card>
      <v-card-text class="pa-4 black--text" style="text-align: center;">
        <div
          class="pt-5 pb-5 top-text text-data-details"
          style="width: 100%; justify-content: center;"
        >
          Digita tu código de validador
        </div>

        <div class="d-flex justify-center mt-5 mb-5">
          <v-otp-input
            v-model="codigo"
            class="mb-8 otp"
            :length="4"
            type="number"
            dark
          />
        </div>

        <v-btn
          class="common-botton"
          dark
          @click="validarCodigo"
          :disabled="codigo.length !== 4"
        >
          Aplicar
        </v-btn>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "./CommonCard.vue";
import { getFolioByCode } from "@/services/solicitudService";

export default {
  components: {
    CommonCard,
  },
  props: {
    dialog: Boolean,
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      },
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.codigo = "";
      }
    },
  },
  data() {
    return {
      codigo: "",
    };
  },
  methods: {
    async validarCodigo() {
      if (this.codigo.length !== 4) return;

      try {
        const solicitudId = this.$route.params.idSolicitud;

        const res = await getFolioByCode({
          solicitudId: solicitudId,
          codigo: this.codigo,
        });

        this.codigo = "";
        this.$emit("codigo-validado", res.data);
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
  },
};
</script>

<style>
@import "../../css/global-styles.css";

.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
}

.top-text {
  width: 369px;
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.confirmation-text {
  /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

  width: 369px;
  height: 30px;

  /* Subtitle/S */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 110%;
  /* or 15px */
  text-align: center;

  color: #555555;

  /* Inside auto layout */
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}
</style>
